<template>
  <div class="custom-scrollbar">
    <RegAuthForgotTitle :with-go-back="false" :name="pageName" />
    <RegAuthSocial :social-list="socialList" />
    <RegAuthOr />
    <RegAuthForgotTabs class="auth__tabs" />
    <LoginForm />
  </div>
</template>

<script>
import RegAuthForgotTitle from '@/components/BigModal/RegAuthForgot/RegAuthForgotTitle'
import RegAuthForgotTabs from '@/components/BigModal/RegAuthForgot/RegAuthForgotTabs'
import RegAuthOr from '@/components/BigModal/RegAuthForgot/RegAuthOr'
import LoginForm from '@/components/Forms/LoginForm'
import RegAuthSocial from '@/components/RegAuthSocial'

export default {
  name: 'Auth',
  components: {
    RegAuthForgotTabs,
    LoginForm,
    RegAuthSocial,
    RegAuthOr,
    RegAuthForgotTitle,
  },
  data() {
    return {
      infoBlock: true,
      socialList: [
        { social: 'google', icon: 'google-colored' },
        // { social: 'apple', icon: 'apple' },
        // { social: 'facebook', icon: 'facebook' },
      ],
    }
  },
  computed: {
    pageName() {
      return this.$route.query.bigModal || 'registration'
    },
  },
}
</script>

<style lang="scss" scoped>
.auth__tabs {
  margin-top: var(--spaces-l);
}
</style>
